import { useColorScheme } from "@ugitgud/legos/hooks/useColorScheme";
import { DistributiveOmit, WithColorScheme } from "@ugitgud/legos/ui/shared";
import { BaseButtonProps, Button } from "@ugitgud/legos/ui/form/button/Button";
import React from "react";

const schemeClasses = {
  windows: "dark:bg-accent-gold-500 dark:hover:bg-accent-gold-600",
  macOS: "dark:bg-accent-gold-500 dark:hover:bg-accent-gold-600",
  primary: "dark:bg-accent-gold-500 dark:hover:bg-accent-gold-600",
};

type YearInReviewButtonColorSchemes = keyof typeof schemeClasses;

export type YearInReviewButtonProps = DistributiveOmit<BaseButtonProps<"a">, "colorScheme" | "as"> &
  WithColorScheme<{}, YearInReviewButtonColorSchemes>;

export const YearInReviewButton: React.FC<YearInReviewButtonProps> = ({ className, colorScheme, ...rest }) => {
  const finalClasses = useColorScheme({
    classes: schemeClasses,
    default: "primary",
    scheme: colorScheme,
    className,
  });
  return <Button {...(rest as BaseButtonProps<"a">)} as="a" className={finalClasses} />;
};
